export default "__VITE_ASSET__QuUQYTcm__"